import { api } from '@/services/api/AxiosBaseService'

export interface DuplicateInvoice {
  id: string
  code: string | null
  dueDate: string | null
  amount: number
  status: string
  paid: boolean
  method: string | null
  createdAt: string | null
}

export interface DuplicateGroup {
  entityType: 'subscriber' | 'company'
  entityId: string
  entityName: string
  month: string // YYYY-MM
  count: number
  invoices: DuplicateInvoice[]
}

export const DuplicateInvoicesService = {
  async list(): Promise<DuplicateGroup[]> {
    const r = await api.get<{ data: DuplicateGroup[] }>('/financial/duplicate-invoices')
    return r.data.data
  },

  async cancel(id: string): Promise<{ message: string }> {
    const r = await api.post<{ message: string }>(`/financial/duplicate-invoices/${id}/cancel`)
    return r.data
  },

  async archive(payload: { entity_type: 'subscriber' | 'company'; entity_id: string; month: string }): Promise<{ message: string }> {
    const r = await api.post<{ message: string }>('/financial/duplicate-invoices/archive', payload)
    return r.data
  },
}
